export const iconFontAwesomeSportsFitnessRankingStar = (
	<i className="fa-solid fa-ranking-star"></i>
);
